/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OneLineGuideCell as IOneLineGuideCell } from 'client-code/grid-guide';
import { OneLineGuideCell } from './OneLineGuideCell';
import { TOneLineGuideRow } from '../types/TOneLineGuideRow';

export class OneLineGuideRow implements TOneLineGuideRow {
    networkCallId?: number | undefined;

    oneLineGuideRow: Array<OneLineGuideCell>;

    constructor(
        oneLineGuideRow: Array<IOneLineGuideCell>,
        imageHostBaseUrl: string,
        networkCallId?: number,
    ) {
        this.oneLineGuideRow = oneLineGuideRow.map(
            (oneLineGuideCell: IOneLineGuideCell): OneLineGuideCell => {
                return new OneLineGuideCell(oneLineGuideCell, imageHostBaseUrl);
            },
        );
        this.networkCallId = networkCallId;
    }
}
